interface BuildEmailSubjectArgs {
  insuranceClass?: string
  selectedPolicyContents?: Array<{ policy?: { insurer?: { name?: string } } }>
  policyCodes?: string[]
  titlePrefix?: string
  date?: Date
}

function buildEmailSubject({
  insuranceClass,
  selectedPolicyContents = [],
  policyCodes = [],
  titlePrefix = 'Policy Comparison Insight',
  date,
}: BuildEmailSubjectArgs): string {
  const parts: string[] = [titlePrefix]
  if (insuranceClass) parts.push(insuranceClass)

  const insurers = selectedPolicyContents
    .map((pc) => pc?.policy?.insurer?.name)
    .filter(Boolean) as string[]
  const uniqueInsurers = Array.from(new Set(insurers))

  if (uniqueInsurers.length) {
    const shown = uniqueInsurers.slice(0, 3).join(', ')
    const more = uniqueInsurers.length > 3 ? ` +${uniqueInsurers.length - 3} more` : ''
    parts.push(`${shown}${more}`)
  } else if (policyCodes.length) {
    const shown = policyCodes.slice(0, 3).join(', ')
    const more = policyCodes.length > 3 ? ` +${policyCodes.length - 3} more` : ''
    parts.push(`${shown}${more}`)
  }

  const dateStr = (date || new Date()).toISOString().slice(0, 10)
  parts.push(dateStr)
  return parts.join(' - ')
}

interface BuildSimpleEmailMessageArgs {
  html?: string
  text?: string
}

function buildSimpleEmailMessage({ html, text }: BuildSimpleEmailMessageArgs): string {
  const source = html || text || ''
  if (!source) return ''

  const container = document.createElement('div')
  container.innerHTML = source

  container.querySelectorAll('br').forEach((br) => br.replaceWith('\n'))

  container.querySelectorAll('li').forEach((li) => {
    const line = `- ${(li.textContent || '').trim()}\n`
    li.replaceWith(document.createTextNode(line))
  })

  const blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'tr']
  blockTags.forEach((tag) => {
    container.querySelectorAll(tag).forEach((el) => {
      el.insertAdjacentText('beforeend', '\n')
    })
  })

  let result = container.textContent || container.innerText || ''
  result = result
    .replace(/\u00A0/g, ' ')
    .replace(/\r/g, '')
    .replace(/[\t ]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  return result
}

export { buildEmailSubject, buildSimpleEmailMessage }

